import { MaskUtils } from '@presentation/utils'

export const formatAlunoPhone = (value?: string | null) => {
  if (!value) return 'Sem Telefone'

  if (value === 'Sem Telefone') return value

  const formattedValue = MaskUtils.formatPhoneNumber(value)

  return formattedValue ?? value
}
